<template>
  <div class="footer">
    立壕有限公司 Copyright @ 2022
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="stylus">
.footer
  height 50px
  line-height 50px
  width 100%
  font-size 14px
  text-align center
  color #fff
  background-color #484e5c
</style>
